<template>
  <component
    :is="componentIs"
    :id="id"
  />
</template>
<script>
import { KYC_STATUS_ENUM } from '@/enums/kyc.enum'

export default {
  name: 'RecipientBiometryStatus',
  props: {
    status: {
      type: String,
      validation: value => Object.values(KYC_STATUS_ENUM).includes(value)
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    componentIs () {
      const map = {
        [KYC_STATUS_ENUM.PENDING]: () => import('./Pending'),
        [KYC_STATUS_ENUM.DENIED]: () => import('././Denied.vue'),
        [KYC_STATUS_ENUM.DENIED_BY_RISK]: () => import('./Denied.vue'),
        [KYC_STATUS_ENUM.APPROVED]: () => import('./Approved'),
        [KYC_STATUS_ENUM.PARTIALLY_DENIED]: () => import('./PartiallyDenied')
      }

      return map[this.status]
    }
  }
}
</script>
